// extracted by mini-css-extract-plugin
export default {"emptyContent":"Empty_emptyContent__3fjyT","empty":"Empty_empty__EgfOm"};